import { memo } from 'react';
import { TweetPrimitive } from './primitive';
import { areNodePropsEqual } from '../are-node-props-equal';
import i18next from '@/lib/i18n';

const t = (k: string): string => String(i18next.t(k));

export type TweetNodeProps = {
  type: string;
  data: {
    content?: {
      id: string;
      text: string;
      author: string;
      date: string;
    };
    updatedAt?: string;
  };
  id: string;
};

export const TweetNode = memo((props: TweetNodeProps) => (
  <TweetPrimitive {...props} title={t("Tweet")} />
), areNodePropsEqual);
TweetNode.displayName = 'TweetNode';
